import { Link, useLocation, useNavigate, type LinkProps } from 'react-router-dom'
import { isStoryLanding } from '../lib/landingReturn'

export default function LegalDocumentLink({ to, ...props }: Omit<LinkProps, 'onClick' | 'state'>) {
  const location = useLocation()
  const navigate = useNavigate()

  return <Link {...props} to={to} onClick={(event) => {
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey
      || event.currentTarget.target === '_blank' || !isStoryLanding(location.pathname)) return

    const activeLayer = Array.from(document.querySelectorAll<HTMLElement>('[data-flow-layer]'))
      .find((layer) => layer.style.pointerEvents === 'auto')
    const section = event.currentTarget.closest<HTMLElement>('[data-flow-section]')
      ?? activeLayer?.querySelector<HTMLElement>('[data-flow-section]')
    const sectionId = section?.dataset.flowId
    if (!sectionId) return

    event.preventDefault()
    const returnTo = `${location.pathname}${location.search}#${sectionId}`
    // Replace the source entry as well: the browser's Back button must restore the slide too.
    navigate(returnTo, { replace: true, state: location.state })
    navigate(to, { state: { landingReturnTo: returnTo } })
  }} />
}
